import React from 'react'
import styled, { css } from 'styled-components'
import Container from '../shared/Container'
import { mobile } from '../../utils/styles/media'
import { defaultTheme as theme } from '../../theme'

export const Grid = (props: React.ComponentPropsWithoutRef<'div'> | { bigMargin?: boolean }) => (
  <Container lessPadding>
    <GridWrapper {...props} />
  </Container>
)

const GridWrapper = styled.div<{ bigMargin?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  padding: 20px 0 40px 0;
  margin-top: ${p => (p.bigMargin ? '3rem' : 0)};
  ${mobile(
    css`
      padding: 10px 0;
      margin-top: 32px;
    `,
  )}
`

export const GridItem = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  background: #ffffff;
  box-shadow: 0px 28px 53px rgba(0, 0, 0, 0.07), 0px 8.44118px 15.9779px rgba(0, 0, 0, 0.0393306),
    0px 3.50603px 6.63642px rgba(0, 0, 0, 0.0238066), 0px 1.26806px 2.40026px rgba(0, 0, 0, 0.0115598);
  border-radius: 8px;
  max-width: 384px;
  @media (min-width: ${theme.breakpoints.tabletVertical}px) {
    flex-basis: 30%;
    margin-right: 24px;
    margin-bottom: 24px;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  @media (max-width: ${theme.breakpoints.tabletVertical}px) {
    max-width: auto;
    flex-basis: 100%;
    margin-right: 0;
    margin-bottom: 16px;
    max-width: 100%;
  }
`
